import { StatusColorEnum } from './StatusColorEnum'
import { ServiceProviderStatusEnum } from '../../../../lib/graphql'

export const badgeColorByServiceProviderStatus = (
  status: ServiceProviderStatusEnum | undefined | null,
) => {
  switch (status) {
    case ServiceProviderStatusEnum.DRAFT:
      return StatusColorEnum.GREY
    case ServiceProviderStatusEnum.PUBLISHED:
      return StatusColorEnum.GREEN
    case ServiceProviderStatusEnum.REFUSAL:
    case ServiceProviderStatusEnum.BANNED:
      return StatusColorEnum.RED
  }
}
